// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__9tXVr","buttonText":"Button_buttonText__tnmsm"};